import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'

/**
 * One entry in a label's design history. Versions are only recorded for labels
 * created with "Keep version history" switched on.
 */
export interface LabelVersionData {
    id: number
    versionNumber: number
    snapshot?: string | null
    note?: string | null
    labelWidth?: string | number | null
    labelHeight?: string | number | null
    labelUnit?: string | null
    restoredFromId?: number | null
    createdAt: string
    createdBy?: string | null
    /** True for the entry matching the label's current design. */
    isCurrent: boolean
    /** True when this exact design was approved. */
    isApproved?: boolean
    approvedBy?: string | null
    approvedAt?: string | null
}

const routes = {
    list: '/customLabels/{id}/versions',
    restore: '/customLabels/{id}/versions/{versionId}/restore'
}

export default {
    list (
        customLabelId: number,
        callback: ResponseCallback<LabelVersionData[]>
    ) {
        const url = routeUtil.replaceParams(routes.list, { id: customLabelId })
        api.get(url, {}, callback)
    },

    /**
     * Make an earlier design current again. Returns the refreshed history.
     */
    restore (
        customLabelId: number,
        versionId: number,
        callback: ResponseCallback<LabelVersionData[]>
    ) {
        const url = routeUtil.replaceParams(routes.restore, {
            id: customLabelId,
            versionId
        })
        api.post(url, {}, callback)
    }
}
